import { Maybe } from 'maybeasy';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { findLink } from '../../../../../../LinkyLinky';
import { T } from '../../../../../../Translations';
import ModalStore from '../../../../../Modal/Store';
import { Link as LinkT } from '../../../../../../Resource/Types';

export interface Props {
  hideModalStore: ModalStore;
  links: ReadonlyArray<LinkT>;
}

export const removeLink = ({ hideModalStore, links }: Props): Maybe<React.ReactNode> =>
  findLink('hide-learning-collection', links).map(() => (
    <Link
      key="hide-learning-collection"
      to={'#'}
      onClick={() => hideModalStore.open()}
      className="px-4 py-2.5"
      data-intercom-target="remove-collection-action"
    >
      <T kind="Remove from List" />
    </Link>
  ));
